/* eslint-disable */
import React, { useEffect, useState } from 'react'
import H3 from "components/H3";
import whatsappIcon from "_assets/icons/channel/whatsapp.svg";
import callIcon from "_assets/icons/channel/call.svg";
import smsIcon from "_assets/icons/channel/sms.svg";
import otpsmsIcon from "_assets/icons/channel/otp_sms.svg";
import emailIcon from "_assets/icons/channel/email.svg";
import AlertTriangle from '_assets/icons/alert_quota.svg';
import { Alert } from 'utils/Alert';
import applicationSvc from "services/applicationSvc";

import './remaining_quota.scss'

function RemainingQuota(props) {
  const {applicationID} = props;

  const [dataQuota, setDataQuota]= useState()
  const [isTypeWAMarketing, setTypeWAMarketing]= useState(null)
  const [isTypeWAUtility, setTypeWAUtility]= useState(null)
  const [isTypeWAAuthentication, setTypeWAAuthentication]= useState(null)
  const [isTypeSMS, setTypeSMS]= useState(null)
  const [isTypeOTPSMS, setTypeOTPSMS]= useState(null)
  const [isTypeCALL, setTypeCALL]= useState(null)
  const [isTypeEmail, setTypeEmail]= useState(null)
  const [isRemainingLowQuota, setRemainingLowQuota]= useState(
    {
      wa_marketing: false,
      wa_authentication: false,
      wa_utility: false,
      call: false,
      sms: false,
      sms_otp: false,
      email: false
    }
  )

  const getRemainingQuota = async () => {
    try {
      const result = await applicationSvc.getRemainingQuota(applicationID)
      setDataQuota(result.data.data)
      if(result.data.data.remaining_quota.length > 0){
        result.data.data.remaining_quota.forEach((item) => {

          if(item.type === 'wa_marketing'){
            if(item.quota >= item.usage){
              item.totalQuota = item.quota - item.usage
            }
            setTypeWAMarketing(item)
          }
          if(item.type === 'wa_authentication'){
            if(item.quota >= item.usage){
              item.totalQuota = item.quota - item.usage
            }
            setTypeWAAuthentication(item)
          }
          if(item.type === 'wa_utility'){
            if(item.quota >= item.usage){
              item.totalQuota = item.quota - item.usage
            }
            setTypeWAUtility(item)
          }
          if(item.type === 'call'){
            if(item.quota_type === 'menit'){
              if(item.quota >= item.usage){
                item.totalQuota = item.quota - item.usage
              }
              const resultSeconds = item.totalQuota * 60;
              item.quotaSeconds = resultSeconds;
            } else {
              if(item.quota >= item.usage){
                item.totalQuota = item.quota - item.usage
              }
              const resultSeconds = item.totalQuota;
              item.quotaSeconds = resultSeconds;
            }
            setTypeCALL(item)
          }
          if(item.type === 'sms'){
            if(item.quota >= item.usage){
              item.totalQuota = item.quota - item.usage
            }
            setTypeSMS(item)
          }
          if(item.type === 'sms_otp'){
            if(item.quota >= item.usage){
              item.totalQuota = item.quota - item.usage
            }
            setTypeOTPSMS(item)
          }
          if(item.type === 'email'){
            if(item.quota >= item.usage){
              item.totalQuota = item.quota - item.usage
            }
            setTypeEmail(item)
          }
        })

      }
      // Compare totalQuota and Balance Quota
      getListBalanceQuota();
    } catch (error) {
      Alert.showStatus(
        'error',
        'Error',
        error
      )
    }
  }

  const getListBalanceQuota = async () => {
    try {
     const result = await applicationSvc.getBalanceQuota(applicationID)
     if(result.data.data.channel.length > 0){
       sendingNotifBalanceQuota(result.data.data.channel)
       
       result.data.data.channel.forEach((item) => {
         if(item.channel === 'wa_marketing'){
            isRemainingLowQuota.wa_marketing = true;
            setRemainingLowQuota({...isRemainingLowQuota})
          }
          if(item.channel === 'wa_authentication'){
            isRemainingLowQuota.wa_authentication = true;
            setRemainingLowQuota({...isRemainingLowQuota})
          }
          if(item.channel === 'wa_utility'){
            isRemainingLowQuota.wa_utility = true;
            setRemainingLowQuota({...isRemainingLowQuota})
          }
          if(item.channel === 'call'){
            isRemainingLowQuota.call = true;
            setRemainingLowQuota({...isRemainingLowQuota})
          }
          if(item.channel === 'sms'){
            isRemainingLowQuota.sms = true;
            setRemainingLowQuota({...isRemainingLowQuota})
          }
          if(item.channel === 'sms_otp'){
            isRemainingLowQuota.sms_otp = true;
            setRemainingLowQuota({...isRemainingLowQuota})
          }
          if(item.channel === 'email'){
            isRemainingLowQuota.email = true;
            setRemainingLowQuota({...isRemainingLowQuota})
          }
      })
     }
    } catch (error) {
      // Alert.showStatus(
      //   'error',
      //   'Error',
      //   error
      // )
    }
  }

  const sendingNotifBalanceQuota = async (channel) => {
    const reqBody = {
      channels: channel
    }
    try {
      await applicationSvc.sendNotifBalanceQuota(applicationID, reqBody)
    } catch (error) {
      if(error.response.data.messages === "Already exists") return;
      Alert.showStatus(
        'error',
        'Error',
        error
      )
    }
  }

  useEffect(() => {
    getRemainingQuota();
  }, [applicationID])

  return (
    <div className={`${dataQuota?.billing_type !== 'pre-paid' ? 'd-none' : null} wrapper_remaining_quota`}>
      <H3 color="#253858" className="elipsis_custom d-block fsize-16 mt-2 mb-3">Remaining Quota</H3>
      {/* <div className='alert_remaining'>
        <div className='d-flex align-items-center badge-terms'>
          <img src={AlertTriangle} className='me-0'></img>
          <p className='mb-0'>Beberapa quotamu udah habis nih, segera hubungi AM OCA untuk top-up!</p>
        </div>
      </div> */}
      <div className='boxder-white container_box'>
        {isTypeWAMarketing ? 
          <div className='box border_right d-flex flex-column'>
            <div className='mb-4 d-flex flex-column justify-content-center'>
              <div className='d-flex justify-content-center align-items-center fsize-14 fweight-500 cl-neutral400 mb-1'>
                <img width={20} src={whatsappIcon}></img>
                <span className='ms-2'>Whatsapp</span>
              </div>
              <p className='mb-0 text-center fsize-11 font-italic cl-neutral100 fweight-base fweight-400'>Marketing</p>
            </div>
            <div className='text-center'>
              <p className='mb-1 cl-neutral500 fsize-16 fweight-600'>{isTypeWAMarketing.totalQuota ?? 0}</p> 
              <p className='m-0 cl-neutral100 fsize-12 fweight-400'>Sessions</p> 
            </div>
            {isRemainingLowQuota?.wa_marketing ? (
              <div className='wrapper_alert_limit_quota d-flex align-items-center justify-content-center mt-4'>
                <img src={AlertTriangle} className='me-0'></img>
                <p className='mb-0 cl-yellow fweight-600 fsize-11 ms-2'>Quota Usage Warning</p>
              </div>
            ) : null}
          </div>
        : null }
        {isTypeWAUtility ? 
        <div className='box border_right d-flex flex-column'>
          <div className='mb-4 d-flex flex-column justify-content-center'>
            <div className='d-flex justify-content-center align-items-center fsize-14 fweight-500 cl-neutral400 mb-1'>
              <img width={20} src={whatsappIcon}></img>
              <span className='ms-2'>Whatsapp</span>
            </div>
            <p className='mb-0 text-center fsize-11 font-italic cl-neutral100 fweight-base fweight-400'>Utility</p>
          </div>
          <div className='text-center'>
            <p className='mb-1 cl-neutral500 fsize-16 fweight-600'>{isTypeWAUtility.totalQuota ?? 0}</p> 
            <p className='m-0 cl-neutral100 fsize-12 fweight-400'>Sessions</p> 
          </div>
          {isRemainingLowQuota?.wa_utility ? (
            <div className='wrapper_alert_limit_quota d-flex align-items-center justify-content-center mt-4'>
              <img src={AlertTriangle} className='me-0'></img>
              <p className='mb-0 cl-yellow fweight-600 fsize-11 ms-2'>Quota Usage Warning</p>
            </div>
          ) : null}
        </div>
          : null }
        {isTypeWAAuthentication ? 
          <div className='box border_right d-flex flex-column'>
            <div className='mb-4 d-flex flex-column justify-content-center'>
              <div className='d-flex justify-content-center align-items-center fsize-14 fweight-500 cl-neutral400 mb-1'>
                <img width={20} src={whatsappIcon}></img>
                <span className='ms-2'>Whatsapp</span>
              </div>
              <p className='mb-0 text-center fsize-11 font-italic cl-neutral100 fweight-base fweight-400'>Authentication</p>
            </div>
            <div className='text-center mt-0'>
              <p className='mb-1 cl-neutral500 fsize-16 fweight-600'>{isTypeWAAuthentication.totalQuota ?? 0}</p> 
              <p className='m-0 cl-neutral100 fsize-12 fweight-400'>Sessions</p> 
            </div>
            {isRemainingLowQuota?.wa_authentication ? (
              <div className='wrapper_alert_limit_quota d-flex align-items-center justify-content-center mt-4'>
                <img src={AlertTriangle} className='me-0'></img>
                <p className='mb-0 cl-yellow fweight-600 fsize-11 ms-2'>Quota Usage Warning</p>
              </div>
            ) : null}
          </div>
        : null }
        {isTypeCALL ? 
          <div className='box border_right d-flex flex-column'>
            <div className='mb-4 d-flex flex-column justify-content-center'>
              <div className='d-flex align-items-center justify-content-center fsize-14 fweight-500 cl-neutral400 mb-1'>
                <img width={20} src={callIcon}></img>
                <span className='ms-2'>Call</span>
              </div>
              <p className='invisible mb-0 ms-4 ps-1 fsize-11 font-italic cl-neutral100 fweight-base fweight-400'>Utility</p>
            </div>
            <div className='text-center mb-0'>
              <p className='mb-1 cl-neutral500 fsize-16 fweight-600'>
                { isTypeCALL.quotaSeconds ? isTypeCALL.quotaSeconds : isTypeCALL.totalQuota ? isTypeCALL.totalQuota : 0 }
              </p> 
              <p className='m-0 cl-neutral100 fsize-12 fweight-400'>Second</p> 
            </div>
            {isRemainingLowQuota?.call ? (
              <div className='wrapper_alert_limit_quota d-flex align-items-center justify-content-center mt-4'>
                <img src={AlertTriangle} className='me-0'></img>
                <p className='mb-0 cl-yellow fweight-600 fsize-11 ms-2'>Quota Usage Warning</p>
              </div>
            ) : null}
          </div>
        : null }
        {isTypeSMS ? 
          <div className='box border_right d-flex flex-column'>
            <div className='mb-4 d-flex flex-column justify-content-center'>
              <div className='d-flex align-items-center justify-content-center fsize-14 fweight-500 cl-neutral400 mb-1'>
                <img width={20} src={smsIcon}></img>
                <span className='ms-2'>SMS</span>
              </div>
              <p className='invisible mb-0 ms-4 ps-1 fsize-11 font-italic cl-neutral100 fweight-base fweight-400'>Utility</p>
            </div>
            <div className='text-center mt-0'>
              <p className='mb-1 cl-neutral500 fsize-16 fweight-600'>{isTypeSMS.totalQuota ?? 0}</p> 
              <p className='m-0 cl-neutral100 fsize-12 fweight-400'>Messages</p> 
            </div>
            {isRemainingLowQuota?.sms ? (
              <div className='wrapper_alert_limit_quota d-flex align-items-center justify-content-center mt-4'>
                <img src={AlertTriangle} className='me-0'></img>
                <p className='mb-0 cl-yellow fweight-600 fsize-11 ms-2'>Quota Usage Warning</p>
              </div>
            ) : null}
          </div>
        : null }
        {isTypeOTPSMS ? 
          <div className='box border_right d-flex flex-column'>
            <div className='mb-4 d-flex flex-column justify-content-center'>
              <div className='d-flex align-items-center justify-content-center fsize-14 fweight-500 cl-neutral400 mb-1'>
                <img width={20} src={otpsmsIcon}></img>
                <span className='ms-2'>SMS OTP</span>
              </div>
              <p className='invisible mb-0 ms-4 ps-1 fsize-11 font-italic cl-neutral100 fweight-base fweight-400'>Utility</p>
            </div>
            <div className='text-center mt-0'>
              <p className='mb-1 cl-neutral500 fsize-16 fweight-600'>{isTypeOTPSMS.totalQuota ?? 0}</p> 
              <p className='m-0 cl-neutral100 fsize-12 fweight-400'>Messages</p> 
            </div>
            {isRemainingLowQuota?.sms_otp ? (
              <div className='wrapper_alert_limit_quota d-flex align-items-center justify-content-center mt-4'>
                <img src={AlertTriangle} className='me-0'></img>
                <p className='mb-0 cl-yellow fweight-600 fsize-11 ms-2'>Quota Usage Warning</p>
              </div>
            ) : null}
          </div>
        : null }
        {isTypeEmail ?
          <div className='box border_right d-flex flex-column'>
            <div className='mb-4 d-flex flex-column justify-content-center'>
              <div className='d-flex align-items-center justify-content-center fsize-14 fweight-500 cl-neutral400 mb-1'>
                <img width={20} src={emailIcon}></img>
                <span className='ms-2'>Email</span>
              </div>
              <p className='invisible mb-0 ms-4 ps-1 fsize-11 font-italic cl-neutral100 fweight-base fweight-400'>Utility</p>
            </div>
            <div className='text-center mt-0'>
              <p className='mb-1 cl-neutral500 fsize-16 fweight-600'>{isTypeEmail.totalQuota ?? 0}</p> 
              <p className='m-0 cl-neutral100 fsize-12 fweight-400'>Email</p> 
            </div>
            {isRemainingLowQuota?.email ? (
              <div className='wrapper_alert_limit_quota d-flex align-items-center justify-content-center mt-4'>
                <img src={AlertTriangle} className='me-0'></img>
                <p className='mb-0 cl-yellow fweight-600 fsize-11 ms-2'>Quota Usage Warning</p>
              </div>
            ) : null}
          </div>
        : null }
      </div>
    </div>
  )
}

export default RemainingQuota